import React from 'react'
import SigninBox from '../templates/signin/SigninBox'
import SigninLayout from '../templates/signin/SigninLayout';

const SigninPage = () => (
  <SigninLayout>
    <SigninBox />
  </SigninLayout>
)

export default SigninPage



// WEBPACK FOOTER //
// ./src/components/pages/SigninPage.js